import { useRouter } from 'next/router'
import React from 'react'
import Home from '../index'

function Booking() {
    const router = useRouter()
    router.replace({
        pathname: "/book",
        query: router.query
    })

    return (
        <div>
            <Home />
        </div>
    )
}

export default Booking